import React from 'react';

import Footer from '../../components/common/Footer';

import documentIcon from '../../assets/images/icons/document-icon.svg';
import piechartIcon from '../../assets/images/icons/piechart-icon.svg';
import handshakeIcon from '../../assets/images/icons/handshake-icon.svg';
import stackIcon from '../../assets/images/icons/stack-icon.svg';
import scalesIcon from '../../assets/images/icons/scales-icon.svg';
import syndicateSvg from '../../assets/images/icons/syndicate-icon.svg';

import portalExample from '../../assets/images/examples/projects.png';

import {
  Button,
  Sitemap,
  MetricsList,
  TestimonialsList,
  Topbar,
} from '../../components/common';
import { Testimonials } from '../../utils/Testimonials';

import './Partners.scss';
import { FloatingList } from '../../components/common/FloatingList/FloatingList';
import { generateBem } from '../../utils/generateBem';

const bem = generateBem('Partners');

const floatingList = [
  {
    icon: documentIcon,
    iconClassName: bem('floatingIcon'),
    title: 'Formation Automation',
  },
  {
    icon: piechartIcon,
    title: 'Fund Administration',
  },
  {
    icon: handshakeIcon,
    iconClassName: bem('floatingIcon'),
    title: 'Transaction Ecosystems',
  },
  {
    icon: syndicateSvg,
    // iconClassName: bem('floatingIcon'),
    title: 'AI & SaaS Enablement',
  },
  {
    icon: stackIcon,
    iconClassName: bem('floatingIcon'),
    title: 'Tech Stack Integration',
  },
  {
    icon: scalesIcon,
    iconClassName: bem('floatingIcon'),
    title: 'Legal & Finance Innovation',
  },
];

const Partners = ({ location: { search } }) => (
  <>
    <Topbar />
    <section className={`${bem('heroSection')} container`}>
      <div className="row">
        <div className={bem('heroColumn')}>
          <div className={bem('heroTextWrapper')}>
            <h1 className={bem('heroHeading')}>
              AI-Enabled
              <br />
              Partner Suite
            </h1>
            <h3 className={bem('heroSubtext')}>
              Launch your private capital client platform.
            </h3>
          </div>
          <Button
            className={bem('heroButton')}
            isFlat
            href="https://share.hsforms.com/10KQq5Zo2Tx6UFEsRLy6Deg2rvzm"
          >
            Talk to Sales
          </Button>
        </div>
        <div className={bem('heroImageWrapper')}>
          <img
            className={bem('heroImage')}
            src={portalExample}
            alt="PaperOS Site Example"
          />
          <div className={bem('floatingList')}>
            <FloatingList items={floatingList} zIndex="80" />
          </div>
        </div>
      </div>
    </section>
    <section className="container container--light">
      <div className="row">
        <MetricsList />
      </div>
    </section>
    <section className="container">
      <div className="row">
        <TestimonialsList listItems={Testimonials} />
      </div>
    </section>
    <Sitemap />
    <Footer />
  </>
);

export default Partners;
